import {
  FilterBtnsStyled,
  TransactionStatusTagStyled,
} from './shared_componentes.styled';
import ReactSelect from 'react-select';
import {
  getTransactionMethodOptionsFromTransactions,
  getTransactionTypeOptionsFromTransactions,
  getStatusOptionsFromTransactions,
} from '../functions/ledger_functions';
import { DateTimeFormatDateOnly } from '../../../config/constants';
import { DatePicker } from 'antd';
import { Transaction } from '../../../data/types/transactions';
import { formatPrice } from '../../../utils/functions/formatting_functions';
const { RangePicker } = DatePicker;

export const TransactionStatusTag = (status_name: string) => {
  return (
    <TransactionStatusTagStyled>
      <span
        className={` 
        status-${status_name.toLowerCase()}`}
        style={{
          borderRadius: '8px',
          fontSize: '12px',
          padding: '6px',
        }}
      >
        {status_name.toUpperCase()}
      </span>
    </TransactionStatusTagStyled>
  );
};

type TransactionsFilterBtnProps = {
  transactions: Transaction[];
  filters: any;
  setFilters: any;
};
export const TransactionsFilterBtns = ({
  transactions,
  filters,
  setFilters,
}: TransactionsFilterBtnProps) => {
  const handleDates = (e: any) => {
    // TODO fix any
    setFilters({
      ...filters,
      date: e,
    });
  };
  return (
    <FilterBtnsStyled>
      <div className="filter">
        <label className="">Date range</label>
        <RangePicker
          format={DateTimeFormatDateOnly}
          onChange={(_: any, dateStrings) => handleDates(dateStrings)}
          style={{ height: '40px', borderRadius: '5px', width: '250px' }}
        />
      </div>
      <div className="filter">
        <label>Type</label>
        <ReactSelect
          placeholder={
            filters?.types?.length === 1 ? filters.types[0].toString() : 'All'
          }
          isMulti={true}
          onChange={(val) =>
            setFilters({
              ...filters,
              types: val.map((item) => item.value),
            })
          }
          options={getTransactionTypeOptionsFromTransactions(transactions)}
        />
      </div>
      <div className="filter">
        <label>Method</label>
        <ReactSelect
          placeholder={
            filters?.methods?.length === 1
              ? filters.methods[0].toString()
              : 'All'
          }
          isMulti={true}
          onChange={(val) =>
            setFilters({
              ...filters,
              methods: val.map((item) => item.value),
            })
          }
          options={getTransactionMethodOptionsFromTransactions(transactions)}
        />
      </div>
      <div className="filter">
        <label className="">Status</label>
        <ReactSelect
          placeholder={
            filters?.statuses?.length === 1
              ? filters.statuses[0].toString()
              : 'All'
          }
          isMulti={true}
          onChange={(val) =>
            setFilters({
              ...filters,
              statuses: val.map((item) => item.value),
            })
          }
          options={getStatusOptionsFromTransactions(transactions)}
        />
      </div>
      <div className="filter">
        <label className="">Balance</label>
        <p>
          {transactions.length > 0
            ? (transactions[0] as any)?.balance !== undefined
              ? formatPrice(
                  (transactions[transactions.length - 1] as any).balance,
                )
              : formatPrice(
                  (transactions[transactions.length - 1] as any)
                    .revenue_balance_debt_to_driver,
                )
            : formatPrice('0')}
        </p>
      </div>
    </FilterBtnsStyled>
  );
};
